import {TabPanel, TabView} from "primereact/tabview";
import {useTranslation} from "react-i18next";

import DoneTab from "./DoneTab";
import SnapshotStatisticsPanel from "./SnapshotStatisticsPanel";
import TabHint from "./TabHint";
import ValuationsTable from "./ValuationsTable";

interface AdminTabProps {
    className?: string;
}

/**
 * #19113: "Alle/Team" tab (TEAMADMIN) of the start page, visible only with the reva-ownership-admin permission (gated in
 * {@link PageStart}). Groups three cross-user views into sub-tabs:
 * <ul>
 *     <li>"Alle offenen Bewertungen" — all valuations of all users ({@link ValuationsTable} with tab="TEAMADMIN").</li>
 *     <li>"Historie" — all users' snapshots ({@link DoneTab} in the "all" scope, with an author column).</li>
 *     <li>"Statistiken" — snapshot activity statistics over all users ({@link SnapshotStatisticsPanel} in the "all" scope).</li>
 * </ul>
 * An explanatory sentence sits above the sub-tabs. Each sub-tab's content is mounted (and its data loaded)
 * on demand, on first activation (PrimeReact default).
 */
export default function AdminTab({className}: AdminTabProps) {
    const {t} = useTranslation();
    return (
        <div className={className}>
            <TabHint>{t("start.admin.explanation")}</TabHint>
            <TabView>
                <TabPanel header={t("start.admin.tabs.valuations")}>
                    <ValuationsTable tab="TEAMADMIN" className="mt-2" />
                </TabPanel>
                <TabPanel header={t("start.admin.tabs.history")}>
                    <DoneTab className="mt-2" scope="all" />
                </TabPanel>
                <TabPanel header={t("start.admin.tabs.statistics")}>
                    <SnapshotStatisticsPanel className="mt-2" scope="all" />
                </TabPanel>
            </TabView>
        </div>
    );
}
